<aside *ngIf="isSticky" class="sticky-offer relative-left full-width txt-center light-2" [ngClass]="[setBgColor]" [@stickyAnim]="isSticky">
  <div class="content-wrap">
    <h2 class="sticky-title relative">
      <ng-content></ng-content>
    </h2>
  </div>
  <div class="sticky-close absolute top-50p">
    <button (click)="closeSticky()" class="mat-sm" mat-icon-button aria-label="Modal close icon" aria-hidden="true">
      <mat-icon inline>
        close
      </mat-icon>
    </button>
  </div>
</aside>
